import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";
import styled, { css } from "styled-components";
import { MoreOutlined } from "@ant-design/icons";
import { getPhotoForUserId, validateValue } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import ArsenalInfoModal from "../ui/ArsenalInfoModal";
import ConfirmDeleteArsenal from "../ui/ConfirmDeleteArsenal";
import "./styles.css";
import BallShadow from "../../images/arsenal_shadow.png";
import Image from "../ui/Image";
import { parseExtraValues } from "../../utils/extraValues";

export const ContainerMod = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.view === "one" ? "row" : "column")};
  justify-content: space-between;
  padding: 0;
  margin: 0 0 10px;
  min-width: ${(props) =>
    props.view === "three"
      ? "31%"
      : props.view === "one"
      ? "98%"
      : "47%"};
  width: ${(props) =>
    props.view === "three"
      ? "31%"
      : props.view === "one"
      ? "98%"
      : "47%"};
  height: unset;
  aspect-ratio: ${(props) =>
    props.isGallery
      ? "261 / 156"
      : props.view === "one"
      ? "260 / 106"
      : "4 / 5"};

  @media only screen and (max-width: 480px) {
    width: 98%;
    min-width: 98%;
  }
`;

const ShadowImage = styled.div`
  position: absolute;
  bottom: -12px;
  background-image: url(${BallShadow});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  width: 100%;
  height: 25px;
`;

const TextStyles = styled.span`
  font-family: Poppins, sans-serif;
  font-size: 13px;
  text-align: left;
  letter-spacing: 0;
  color: #00000099;
  font-weight: 400;
  line-height: 1.3;
  cursor: pointer;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(props) =>
    props.nameStyle &&
    css`
      font-size: 14px;
      font-weight: 700;
      color: #00187e;
      text-transform: uppercase;
      letter-spacing: 0.4px;
    `}
  ${(props) =>
    props.specificationStyle &&
    css`
      font-size: 12px;
      color: #6b7280;
      margin-top: 2px;
    `}
  ${(props) =>
    props.descriptionStyle &&
    css`
      font-size: 12px;
      color: #6b7280;
    `}
  ${(props) =>
    props.dateStyle &&
    css`
      font-size: 10px;
      color: #9ca3af;
      margin-top: 6px;
    `}
`;

const CardContainer = styled(Card)`
  position: relative;
  background-color: ${(props) =>
    props.ball_enable === true ? "#ffffff" : "#00000099"};
  border: 1px solid #ececef;
  border-radius: 12px;
  overflow: hidden;
  height: 100%;
  width: 100%;
  box-shadow: 0 1px 3px rgba(16, 24, 64, 0.06);
  transition: box-shadow 0.18s ease, transform 0.18s ease,
    border-color 0.18s ease;

  &:hover {
    box-shadow: 0 8px 22px rgba(16, 24, 64, 0.12);
    border-color: #d8dbe8;
    transform: translateY(-2px);
  }
`;

const Button = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  border-radius: 50%;
  background: #00147b80 0% 0% no-repeat padding-box;
  color: #ffffff;
  width: 30px;
  height: 30px;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #00147b 0% 0% no-repeat padding-box;
  }
`;

const cardBodyPadding = {
  padding: "0",
};

export const ArsenalCard = ({
  name = "",
  serial_number = "",
  layout = "",
  layout_type = "",
  surface_preparation = "",
  date = "",
  ball_enable,
  id = "",
  bowlerID,
  photo,
  userId,
  arsenal_layout_style,
  isGallery = false,
  showActions = false,
  view = "three",
  ballRemove,
  ballHandleForm,
  ballSelect,
  ball,
  isReadOnly,
  pluginSubscriptions,
  woocommerceCheckUserExists,
  selectedCustomer,
}) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showArsenalInfoModal, setShowArsenalInfoModal] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [viewManage, setViewManage] = useState(view);

  const getPhoto = getPhotoForUserId(userId);
  const image = getPhoto(photo);

  let date2 = new Date(date);
  let updateDate =
    date2.getDate() + "/" + (date2.getMonth() + 1) + "/" + date2.getFullYear();

  const handleWoocommerceRemoval = (ball) => {
    woocommerceCheckUserExists({
      first_name: selectedCustomer?.firstname,
      last_name: selectedCustomer?.lastname,
      email: selectedCustomer?.email,
      spectreCustomer: selectedCustomer,
      nextAction: "remove order",
      ball_name: ball.ball_name,
      hbsSku: parseExtraValues(ball?.extra_values).barcode || "",
      orderData: {
        payment_method: "bacs",
        payment_method_title: "Direct Bank Transfer",
        set_paid: false,
        billing: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          address_1: selectedCustomer?.address,
          address_2: "",
          city: selectedCustomer?.city,
          state: selectedCustomer?.state,
          postcode: selectedCustomer?.postal_code,
          country: selectedCustomer?.country,
          email: selectedCustomer?.email,
          phone: selectedCustomer?.telephone,
        },
        shipping: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          company: "",
          address_1: selectedCustomer?.address,
          address_2: "",
          city: selectedCustomer?.city,
          state: selectedCustomer?.state,
          postcode: selectedCustomer?.postal_code,
          country: selectedCustomer?.country,
        },
      },
      customerData: {
        first_name: selectedCustomer?.firstname,
        last_name: selectedCustomer?.lastname,
        email: selectedCustomer?.email,
        username: selectedCustomer.telephone,
        billing: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          company: "",
          address_1: selectedCustomer?.address,
          address_2: "",
          city: selectedCustomer?.city,
          state: selectedCustomer?.state,
          postcode: selectedCustomer?.postal_code,
          country: selectedCustomer?.country,
          email: selectedCustomer?.email,
          phone: selectedCustomer?.telephone,
        },
        shipping: {
          first_name: selectedCustomer?.firstname,
          last_name: selectedCustomer?.lastname,
          company: "",
          address_1: selectedCustomer?.address,
          address_2: "",
          city: selectedCustomer?.city,
          state: selectedCustomer?.state,
          postcode: selectedCustomer?.postal_code,
          country: selectedCustomer?.country,
        },
      },
    });
  };

  const handleDeleteBall = () => {
    // Add call to remove from order if order with the ball exists, and delete the order if it's empty
    if (pluginSubscriptions.indexOf("SPECTRE_POS") >= 0) {
      handleWoocommerceRemoval(ball);
    }
    ballRemove({ id });
  };
  const handleUserNavigate = () => {
    ballSelect({ ball });
  };

  const isOneView = view === "one" && !isGallery;

  const MarginCol = styled.div`
    width: 100%;
    padding: 8px 14px 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: ${isOneView ? "center" : "flex-start"};
    gap: 2px;
    background: #ffffff;
    flex: ${isOneView ? "1 1 auto" : "0 0 auto"};
  `;

  const ImageDiv = styled.div`
    position: relative;
    border-radius: ${isGallery ? "50%" : "0"};
    width: ${isGallery ? "85%" : isOneView ? "90%" : "70%"};
    max-width: 180px;
    height: auto;
    aspect-ratio: ${isGallery ? "1" : "137.07 / 146.69"};
    overflow: visible;
    img.image-loaded {
      aspect-ratio: ${isGallery ? "1" : "137.07 / 146.69"};
    }
  `;

  const CardImage = ({ src, alt }) => (
    <div
      style={{
        width: isOneView ? "40%" : "100%",
        flex: isOneView ? "0 0 40%" : "1 1 auto",
        minHeight: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "12px 12px 4px",
        boxSizing: "border-box",
      }}
    >
      <ImageDiv>
        <Image style={{ width: "100%", height: "unset" }} src={src} alt={alt} />
        <ShadowImage />
      </ImageDiv>
    </div>
  );

  return (
    <>
      <ContainerMod view={view} isGallery={isGallery}>
        <CardContainer
          isGallery={isGallery}
          view={view}
          ball_enable={ball_enable}
        >
          <Card.Body style={cardBodyPadding} onClick={handleUserNavigate}>
            <div
              style={{
                display: "flex",
                flexDirection: isOneView ? "row" : "column",
                width: "100%",
                height: "100%",
              }}
            >
              <Card.Img src={image} fluid={"true"} alt={""} as={CardImage} />
              <MarginCol>
                <TextStyles nameStyle isGallery={isGallery}>
                  {name}
                </TextStyles>
                {validateValue(serial_number) !== "" && (
                  <TextStyles specificationStyle>{serial_number}</TextStyles>
                )}
                {validateValue(layout) !== "" && (
                  <TextStyles descriptionStyle>
                    {validateValue(layout_type) !== "" &&
                    validateValue(layout_type) !== "NONE"
                      ? t(
                          `form.setting.${
                            layout_type || arsenal_layout_style
                          }`
                        ) + " · "
                      : ""}
                    {layout}
                  </TextStyles>
                )}
                {validateValue(surface_preparation) !== "" && (
                  <TextStyles descriptionStyle>
                    {surface_preparation}
                  </TextStyles>
                )}
                <TextStyles dateStyle>{updateDate}</TextStyles>
              </MarginCol>
            </div>
          </Card.Body>
          {showActions && (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setShowArsenalInfoModal(true);
              }}
            >
              <MoreOutlined style={{ fontSize: 22 }} />
            </Button>
          )}
        </CardContainer>
      </ContainerMod>
      <ArsenalInfoModal
        show={showArsenalInfoModal}
        enable={ball_enable}
        onHide={() => {
          setShowArsenalInfoModal(false);
        }}
        onEnableDisable={(enable) => {
          ballHandleForm({
            ball: { ...ball, enable },
          });

          setShowArsenalInfoModal(false);
        }}
        onDelete={() => {
          setShowConfirmDelete(true);
          setShowArsenalInfoModal(false);
        }}
        isReadOnly={isReadOnly}
      />
      <ConfirmDeleteArsenal
        show={showConfirmDelete}
        onHide={() => {
          setShowConfirmDelete(false);
        }}
        onConfirmClick={() => {
          handleDeleteBall();
          setShowConfirmDelete(false);
        }}
      />
    </>
  );
};
